<section class="sh-dialog__content">
    <div *ngIf="config.data.errorMessage" class="sh-notification--error">
        <figure class="sh-notification__icon">
            <svg sh-icon [name]="'delete'"></svg>
        </figure>
        <span>
            <sh-html-parser [message]="config.data.errorMessage"></sh-html-parser>
        </span>
    </div>
    <div *ngIf="config.data.warningMessage" class="sh-notification--warning">
        <figure class="sh-notification__icon">
            <svg sh-icon [name]="'exclamation-circle'"></svg>
        </figure>
        <span>
            <sh-html-parser [message]="config.data.warningMessage"></sh-html-parser>
        </span>
    </div>
    <div *ngIf="config.data.infoMessage" class="sh-notification--update">
        <figure class="sh-notification__icon">
            <svg sh-icon [name]="'info'"></svg>
        </figure>
        <span>
            <sh-html-parser [message]="config.data.infoMessage"></sh-html-parser>
        </span>
    </div>
    <p *ngIf="config.data.message">
        <sh-html-parser [message]="config.data.message"></sh-html-parser>
    </p>
</section>
<footer class="sh-dialog__footer">
    <div class="sh-action-group -sh-align-end">
        <button *ngIf="config.data.yes" type="button" class="sh-button sh-action-group__item" (click)="yes()">{{ config.data.yes }}</button>
        <button *ngIf="config.data.no" type="button" class="sh-button--secondary sh-action-group__item" (click)="no()">{{ config.data.no }}</button>
    </div>
</footer>
